var _path, _circle, _line, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLendingInterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10.5714L23.9209 11.0248C22.4082 11.6604 20.7401 11.8292 19.1308 11.5096L17.6591 11.2172C16.4968 10.9864 15.4707 10.3103 14.8 9.33333V9.33333M25 4.85714L24.8689 4.88898C23.4252 5.23946 21.9071 5.11805 20.5375 4.54256V4.54256C19.6852 4.18446 18.77 4 17.8455 4H17.6743C16.1409 4 14.6415 4.45205 13.3637 5.29962L8.55052 8.492C8.2067 8.72004 8 9.10518 8 9.51775V9.51775C8 10.1243 8.44182 10.6404 9.04108 10.7339L9.4429 10.7966C9.69814 10.8364 9.9591 10.8178 10.2061 10.7421L14.8 9.33333M14.8 9.33333L19.2462 8",
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 21,
    r: 6,
    stroke: "#0BC196",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 22.9393,
    x2: 17.9393,
    y2: 19,
    stroke: "#24D1A8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 19,
    r: 0.5,
    fill: "#0EF1BC",
    stroke: "#0EF1BC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 23,
    r: 0.5,
    fill: "#0EF1BC",
    stroke: "#0EF1BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendingInterest);
export default __webpack_public_path__ + "static/media/lendingInterest.73d6e06da2924cd4e326695c1d9e1f00.svg";
export { ForwardRef as ReactComponent };